export const getBase64 = async (file) => {
  return new Promise((resolve, reject) => {
    let reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = function () {
      const base64data = reader.result
      const strBase64 = base64data.substr(base64data.indexOf(',') + 1)
      resolve(strBase64)
    }
    reader.onerror = reject
  })
}
